.bookingItem {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacingMd);
  width: 100%;
  padding: var(--spacingMd);
  border-top: 1px solid var(--paletteNeutral0);

  &:hover {
    background: var(--paletteTrans0);
  }

  .actionsContainer {
    display: inline-flex;
    justify-content: end;
    align-items: center;
    gap: var(--spacingXs);
  }

  .action {
    margin: var(--spacingSm);
  }
}
